import React from 'react';
import { Fieldset, RadioButton } from '@fourthwall/components';
import { useTierContext } from '../../hooks/useTierContext';
import { FormFields } from '../../providers/TierProvider/types';
export const DiscountType = () => {
    const { form, isLoading } = useTierContext();
    if (form.values.price && parseFloat(form.values.price) === 0)
        return null;
    if (!form.values.discount)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Fieldset.Row, { inner: true },
            React.createElement(RadioButton, { label: "7-day free trial", checkedValue: "trial", disabled: isLoading, tooltip: "New members get 7 days of membership before they are charged.", ...form.getFieldProps(FormFields.discountType) })),
        React.createElement(Fieldset.Row, { inner: true },
            React.createElement(RadioButton, { label: "One-time discount", checkedValue: "oneTime", disabled: isLoading, ...form.getFieldProps(FormFields.discountType) }))));
};
